import type {ReactAction} from '@netx/core/bootstrap';
import {faICursor} from '@fortawesome/pro-solid-svg-icons';
import {canRenameSavedSearch} from '../enablers';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import type {SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';

export const searchSavedActionRenameIcon = faICursor;

/**
 * Rename saved search
 * @param params
 * @returns Action
 */
export const searchSavedActionRename = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-rename',
	cb: () => dispatcher.trigger(SEARCH_SAVED_EVENT.RENAME, savedSearch),
	enableTest: () => canRenameSavedSearch(savedSearch),
	icon: searchSavedActionRenameIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.RENAME;
	},
	...params,
});

export default searchSavedActionRename;
